module.exports = __webpack_public_path__ + "static/merch6Front-febe1e27dd5d33aa22feb85612e83758.png";